import { applyRuntimeLocale, isInstallableLocale } from "./localeRegistry";
import {
  BUILT_IN_SOURCE_LOCALE,
  INSTALLABLE_LOCALES,
  type InstallableLocale,
} from "./preparedLocales";

/**
 * Compatibility exports for older public/auth imports.
 *
 * Runtime authority now lives in localeRegistry + PublicSurfaceFoundation.
 * This module must never reintroduce the retired English-only product policy.
 */
export type PreparedLocale = InstallableLocale;
export const PREPARED_LOCALES = INSTALLABLE_LOCALES;
export const ENABLED_UI_LOCALES = INSTALLABLE_LOCALES;
export const PRODUCT_LOCALE = BUILT_IN_SOURCE_LOCALE;

export function enforceProductLocale(): void {
  const active = document.documentElement.dataset.kavooshLocale;
  if (isInstallableLocale(active)) {
    applyRuntimeLocale(active);
    return;
  }
  applyRuntimeLocale(PRODUCT_LOCALE);
}
